import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxGlobalContactFooterModule } from 'ngx-global-contact-footer';
import { GlobalNavModule } from 'ngx-global-nav';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { AlertModule } from './shared/component/global/alert/alert.module';
import { LoaderModule } from './shared/component/global/loader/loader.module';
import { TreeModule } from '@component';
import { CoreModule } from '@core';
import { UserMenuComponent } from './shared/components/user-menu/user-menu.component';

@NgModule({
  declarations: [AppComponent, UserMenuComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    TreeModule,
    AlertModule,
    FormsModule,
    NgxGlobalContactFooterModule.forRoot({
      namespace: 'ngx-global-contact-footer.',
    }),
    GlobalNavModule.forRoot({ namespace: 'ngx-global-nav.' }),
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatExpansionModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSnackBarModule,
    ScrollingModule,
    CommonModule,
    LoaderModule,
    AlertModule,
  ],
  exports: [BrowserModule, BrowserAnimationsModule, CoreModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
